import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";function ownKeys(object, enumerableOnly) {var keys = _Object$keys(object);if (_Object$getOwnPropertySymbols) {var symbols = _Object$getOwnPropertySymbols(object);enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {return _Object$getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));});}return target;}import clsx from 'clsx';
import { Button } from "./..";
import { ChevronDown, ChevronUp } from "../../icons";
import React, { useState } from 'react';

import { createStyles } from "./styles";

var Guideline = function Guideline(props) {
  var _useState = useState(props.showGuidelinesByDefault || false),_useState2 = _slicedToArray(_useState, 2),showGuidelines = _useState2[0],setShowGuidelines = _useState2[1];

  var changeGuidelinesHandler = function changeGuidelinesHandler() {
    setShowGuidelines(!showGuidelines);
  };
  var classes = createStyles(_objectSpread(_objectSpread({}, props), {}, { showGuidelines: showGuidelines }));
  var showGuidelineLabel = props.labels ? props.labels.closed : 'Hide Guidelines';
  var hideGuidelineLabel = props.labels ? props.labels.opened : 'Show Guidelines';

  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(
      classes.guidelinesWrapper,
      props.simpleStyles && classes.simpleGuidelineWrapper,
      props.className) }, /*#__PURE__*/


    React.createElement(Button, {
      type: "text",
      rightIconProp: showGuidelines ? /*#__PURE__*/React.createElement(ChevronUp, null) : /*#__PURE__*/React.createElement(ChevronDown, null),
      className: classes.actionButton,
      onClick: changeGuidelinesHandler },

    showGuidelines ? showGuidelineLabel : hideGuidelineLabel),

    showGuidelines && /*#__PURE__*/
    React.createElement(React.Fragment, null,
    props.content && /*#__PURE__*/React.createElement("div", null, props.content),
    props.text && /*#__PURE__*/
    React.createElement("div", {
      dangerouslySetInnerHTML: { __html: props.text },
      className: classes.guidelinesText }))));






};

export default Guideline;
//# sourceMappingURL=index.js.map